import React, { FC } from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
} from '@mui/material';
import { Typography700 } from 'views/rebranded-module/common/components';
import StyledBox from 'views/rebranded-module/membership-module/MembershipLandingViewV2/components/WhyJoinSection/WhyJoinSection.styles';
import { 
  RiCalendarCheckFill, 
  RiGuideLine,
  RiEmotionHappyLine,
  RiTeamLine,
} from 'react-icons/ri';
import { useContent } from 'views/rebranded-module/common/context/useContent';

const WhyJoinSection: FC<any> = () => {

  const content = useContent('MembershipLandingPage');

  // Define icons in the same order as the CMS items
  const icons = [
    <RiCalendarCheckFill className='WJSIcon' />, 
    <RiGuideLine className='WJSIcon' />,        
    <RiEmotionHappyLine className='WJSIcon' />, 
    <RiTeamLine className='WJSIcon' />,   
  ];

  return (
    <StyledBox>
      <Container maxWidth="xl">
        <Grid container spacing={4}>
          {content.whyJoinItems.map((item, index) => (
            <Grid item lg={3} md={6} sm={12} key={index}>
              <Box className="WJSItem">
                {icons[index]}
                <Typography700 variant='h5' component="p">
                  {item.title}
                </Typography700>
                <Typography variant='body2' component="p" className="WJSDesc">
                  {item.description}
                </Typography>
              </Box>
            </Grid>  
          ))}
        </Grid>
      </Container>
    </StyledBox>
  );
};

export { WhyJoinSection };